import { NgModule } from '@angular/core';
import { SiModalModule } from '../si-modal';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { ReConnectSettingComponent } from './re-connect-setting.component';

@NgModule({
  imports: [
    CommonModule,
    SiModalModule,
    TitleCasePipe,
  ],
  declarations: [ReConnectSettingComponent],
  exports: [ReConnectSettingComponent]
})
export class ReConnectSettingModule { }
